'use strict'

import WPAPI from 'wpapi'
import listingsSearch from './listings.search'

let self

export default self = {
  wp : null,
  base : 'wp-json',
  postsPerPage : 100,
  getUrl : (endpoint = '') => `/${self.base}/${endpoint}`,

  init : () => {
    self.wp = self.connect()
    self.setupCustomRoutes()
  },

  connect : () => new WPAPI({
    endpoint: window.WP_API_Settings.endpoint,
    nonce: window.WP_API_Settings.nonce
  }),

  setupCustomRoutes : () => {
    self.wp.publicListings = self.wp.registerRoute( 'wp/v2', '/public_listings/(?P<id>)', { params: ["filter"] }  )
    self.wp.publicListingsMeta = self.wp.registerRoute( 'acf/v3', '/public_listings/(?P<id>)', { params: ["filter"] } )
    self.wp.buildings = self.wp.registerRoute( 'wp/v2', '/buildings/(?P<id>)', { params: ["filter"] }  )
    self.wp.usersMeta = self.wp.registerRoute( 'acf/v3', '/users/(?P<id>)' )
  },

  getAllPublicListings : ({ page }) => new Promise( (resolve, reject) => {
    self.wp.publicListings().perPage(self.postsPerPage).page(page)
      .then( res => resolve(res) )
      .catch( err =>  reject(err) )
  }),

  deleteSearchDataFor : ({ index, userID }) => {
    self.wp.usersMeta().id(userID)
      .then( res => {
        const allSearches = JSON.parse(res.acf.saved_searches)
              allSearches.splice(index, 1)

        return self.wp.usersMeta().id(userID).update({
          fields : {
            saved_searches : JSON.stringify(allSearches)
          }
        })
      })
      .then( res => console.log(res.acf.saved_searches))
  },

  saveSearchDataFor : ({userID, searchParams, searchName}) => {
    console.log("saveSearchDataFor", userID, searchParams, searchName);
    const overlay = document.getElementById('savedSearchOverlay')
    const fields = { saved_searches : [] }
    const newSearch = { name : searchName, params : searchParams }
    console.log(`newSearch`, newSearch);

    // Set the overlay to the loading state
    overlay.setAttribute('rel', 'loading')

    // Get the current user's meta data (acf fields)
    self.wp.usersMeta().id(userID)
      .then( res => {
        let allSearches = (res.acf.saved_searches && res.acf.saved_searches.length > 0) ? JSON.parse(res.acf.saved_searches) : []
            allSearches.push(newSearch)
        console.log(allSearches);
        return self.wp.usersMeta().id(userID).update({
          fields : {
            saved_searches : JSON.stringify(allSearches)
          }
        })
      })
      .then( res => {
        overlay.setAttribute('rel', 'success')
        listingsSearch.closeSearchOverlay({ delay : 1000 })
      })
      .catch( err => {
        console.error(err);
        overlay.setAttribute('rel', 'error')
        listingsSearch.closeSearchOverlay({ delay : 1000 })
      })
  }
}
